<template>
	<div>
		<v-container grid-list-md>
			<h1>
				{{ $t('music.mixes') }}
				<v-btn
					large
					text
					icon
					color="#FE5000"
					target="_blank"
					href="https://soundcloud.com/petrovicz"
				>
					<v-icon large>fab fa-soundcloud</v-icon>
				</v-btn>
			</h1>

			<v-layout row wrap>
				<v-flex xs12 lg6 v-for="item in items" :key="item.id">
					<iframe
						width="100%"
						height="166"
						scrolling="no"
						frameborder="no"
						allow="autoplay"
						:src="item.url"
					></iframe>
				</v-flex>
			</v-layout>
		</v-container>

		<!-- <v-container grid-list-lg>
			<h1>{{ $t('music.gear') }}</h1>

			<v-layout row wrap>
				<v-flex xs12 sm8>
					<v-card height="100%">
						<v-img
							contain
							height="400"
							:src="require('@/assets/img/ddj-rb.png')"
						></v-img>
						<v-card-title class="title">DDJ-RB</v-card-title>
					</v-card>
				</v-flex>
				<v-flex xs12 sm4>
					<v-card>
						<v-img
							contain
							height="400"
							:src="require('@/assets/img/headphones.png')"
						></v-img>
						<v-card-title class="title"
							>Audio Technica ATH-M50xBT</v-card-title
						>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container> -->
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			items: [
				{
					id: 1,
					url:
						'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/495607716&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
				},
				{
					id: 2,
					url:
						'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/488778756&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
				},
				{
					id: 3,
					url:
						'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/479829651&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
				},
				{
					id: 4,
					url:
						'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/460122117&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
				},
				{
					id: 5,
					url:
						'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/456774780&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
				}
			]
		};
	}
};
</script>
